import { Download, Cpu } from 'lucide-react'

interface GeneratedImage {
  id: string
  url: string
  prompt: string
  model: string
  created_at: string
  cached?: boolean
}

interface ImageGalleryProps {
  images: GeneratedImage[]
  onDownload: (url: string, filename?: string) => void
}

export function ImageGallery({ images, onDownload }: ImageGalleryProps) {
  return (
    <div className="bg-[#161b22] rounded-xl p-4 border border-cyan-900/30">
      <h3 className="text-sm font-semibold mb-4 text-white">生成历史</h3>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {images.map((image) => (
          <div key={image.id} className="group relative bg-[#0d1117] rounded-lg overflow-hidden border border-cyan-900/30 hover:border-cyan-500/50 transition-colors">
            <div className="aspect-square relative overflow-hidden">
              <img
                src={image.url}
                alt={image.prompt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                <button
                  onClick={() => onDownload(image.url, `generated-${image.id}.png`)}
                  className="bg-white/20 hover:bg-white/30 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors"
                >
                  <Download className="w-4 h-4" />
                  <span>下载</span>
                </button>
              </div>
              {image.cached && (
                <div className="absolute top-2 right-2 bg-yellow-500/80 text-yellow-900 px-2 py-1 rounded text-xs font-medium">
                  缓存
                </div>
              )}
            </div>
            
            <div className="p-2 space-y-1">
              <p className="text-xs text-gray-300 line-clamp-1" title={image.prompt}>
                {image.prompt}
              </p>

              <div className="flex items-center justify-between text-xs text-gray-500">
                <div className="flex items-center space-x-1">
                  <Cpu className="w-2 h-2" />
                  <span className="truncate">{image.model.split('/').pop()}</span>
                </div>
                <span>{new Date(image.created_at).toLocaleDateString()}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      {images.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-400">暂无生成记录</p>
        </div>
      )}
    </div>
  )
}
